<template>
    <a href="javascript:;" class="c-btn c-btn--secondary c-btn--small block w-full" @click.prevent="logout()">Logout</a>
</template>

<script>
export default {
    methods: {
        logout() {
            this.$axios.post(route('logout')).then(response => {
                window.location = route('home');
            });
        },
    },
};
</script>
